<lui-layout-main>
  <router-outlet></router-outlet>

  <ng-container
    *ngrxLet="{
      portal: bottomBarService.portal$,
      state: bottomBarService.state$
    } as data"
  >
    <div
      [@bottomBar]="!data.portal ? 'hidden' : data.state"
      class="bottom-bar bottom-0 z-2 overflow-hidden w-100"
      [ngClass]="{
        'position-sticky': bottomBarService.config.position === 'sticky',
        'position-fixed': bottomBarService.config.position === 'fixed'
      }"
      data-test="bottom-bar"
      [attr.data-test-state]="data.state === 'hidden' ? 'hidden' : 'visible'"
    >
      <ng-container *ngIf="data.portal">
        <ng-template [cdkPortalOutlet]="data.portal"></ng-template>
      </ng-container>
    </div>
  </ng-container>

  <lui-footer-basic [links]="footerLinks$ | async" [copyright]="copyright">
  </lui-footer-basic>
</lui-layout-main>

<lui-loading-overlay
  *ngIf="loading$ | async"
  class="loading-overlay"
  data-test="loading-overlay"
></lui-loading-overlay>
